import { Flex } from '@chakra-ui/react';
import { ContentContainerType } from 'types/enums';
import {
  AudioSelectionItem,
  SelectedAudioObject,
  AudioSelectList,
} from 'app/components/Audio';
import { ContentContainer } from 'app/components/Core';
import { OverlayDialog, OverlayHeader } from 'app/components/Dialogs';
import { useCreatePlaylist } from 'app/components/Playlist/hooks';

interface PlaylistAudioSelectOverlayProps {
  onClose: () => void;
  onAdd?: (audios: SelectedAudioObject) => Promise<void>;
  preselectedAudio?: AudioSelectionItem;
  songGuid?: string;
}

export const PlaylistAudioSelectOverlay = ({
  onClose,
  onAdd,
  preselectedAudio,
  songGuid,
}: PlaylistAudioSelectOverlayProps) => {
  const { maxPlaylistAudios, handleOnAdd } = useCreatePlaylist(songGuid, () => {
    onClose();
  });

  return (
    <OverlayDialog onClose={onClose}>
      <Flex direction="column" height="100%">
        <ContentContainer
          type={ContentContainerType.LIST}
          sx={{
            overflow: 'hidden',
            height: '100%',
          }}
        >
          <OverlayHeader headerText="Choose Audio files" mb={6} />
          <AudioSelectList
            onCancel={onClose}
            emptyStateMessage="It looks like you don't have any audio files. Upload audio to a song and try again."
            onAdd={onAdd || handleOnAdd}
            preselectedAudio={preselectedAudio}
            maxAudioCount={maxPlaylistAudios}
            checkAllOptions={['Bounce', 'Idea', 'Mix', 'Master', 'Stem']}
          />
        </ContentContainer>
      </Flex>
    </OverlayDialog>
  );
};
